import { Injectable, Input, EventEmitter, Output } from '@angular/core';
import { BaseService } from './BaseService';
import { APIServiceConnector } from './APIServiceConnector';
import { MetaDataCache } from '../Models/CommonModels';
import * as enumModels from '../Models/EnumModels';
import { MasterDataRequest, GuestSearch, AddPreferenceRequest, CurrentReservationSearch, MessageOperationRequest, MessageSearch, ListRequest } from '../Models/RequestModels';
import { UIState, UserState, ModuleMultilingualLabels } from '../Models/UIModels';
import { AppSettings } from '../Library/AppSettings';
import { MasterDataService } from './MasterDataService';
import { EntityCodes, MessageOperations, DeviceTypes } from '../Models/EnumModels';
import { StaffMessageRequest } from '../Models/RequestModels';
import { SimpleResponse, ListResponse } from '../Models/ResponseModels';
import * as _ from "lodash";
import { Title } from '@angular/platform-browser';


@Injectable()
export class MessagingService extends BaseService {
    @Output() NotificationCenter_Visibility: EventEmitter<boolean> = new EventEmitter<boolean>();

    NC_Visiblity: boolean = false;
    MessageCache: Array<any> = new Array<any>();
    public MessageCacheChanged: EventEmitter<any> = new EventEmitter<any>();
    private timeout;

    constructor(public apiService: APIServiceConnector, public masterService: MasterDataService, private title: Title) {
        super();
        this.BaseURL = AppSettings.URL_Messaging;

        //this.NotificationAudio = new Audio("/Assets/notification.mp3");
        //this.MessageCache = JSON.parse('[{"tablename":"message","propertyid":4146,"messageid":"d927fc5f-759e-4b20-839c-ce829de11045","staffid":30094,"num":4228885,"status":"s","sent":null,"createdat":"2018-08-29t08:28:11.057z","deviceaddress":"","messagetype":1,"devicetype":1,"device":"pc","subject":"call assign","message":"call no  1217 location name  <location> guest name  <guestname> call description  hot / ice pack delivery priority  normal maximum response time  20.0 call reg remarks   property name  rwsbv","confirmtime":null,"senttime":"2018-08-29t08:28:11.057z","deliveredt":null,"isread":false,"owner":30094,"eventid":1003,"transid":null,"displayno":"1707","moduletype":"rapid","lastupdate":"2018-08-29t08:28:11.057z","statustransactionid":null,"eventdescription":"call assignment ","ownerid":30094,"ownername":"test sm 12","ownerlanguagecode":"eng","reason":null,"readcount":null}]');
        //for (let i = 0; i < 20; i++) {
        //    this.MessageCache.push(this.MessageCache[0]);
        //}
    }

    ngOnInit() {

    }

    ToggleNotificationCenter(): void {
        this.NC_Visiblity = !this.NC_Visiblity;

        //let msgTemp = JSON.parse('[{"MessageId":"78a80d37-76e7-4c2a-b058-92d2539b2861","Operation":2},{"MessageId":"ed602641-3966-4fa5-a7a5-2c34fcb17f68","Operation":2},{"MessageId":"5c99f1cc-37a4-44eb-9185-a550fd4333fe","Operation":2},{"MessageId":"969fbccc-3f8e-4d70-83a8-658e71c95acf","Operation":2},{"MessageId":"8e11932c-0b45-4286-827d-a7cf0a422569","Operation":2},{"MessageId":"eeae4040-bdc4-46c3-a108-d822ff805c5a","Operation":2},{"MessageId":"f825d118-fe88-478a-b303-a33ba8cb78b9","Operation":2},{"MessageId":"b709b2df-4320-4e66-90f0-036aa04b4a84","Operation":2},{"MessageId":"1c79c769-0e11-48ad-9300-e840f576f018","Operation":2},{"MessageId":"f8ac1c63-4dc4-446a-a55b-0ce79a43a498","Operation":2},{"MessageId":"df868edc-60fb-4f08-b4a8-f7a202410bf3","Operation":2},{"MessageId":"a59d359d-865d-48ae-9bf7-bad340c71184","Operation":2},{"MessageId":"118b2618-2f3f-4f57-ad40-ba0bc051c389","Operation":2},{"MessageId":"c51a4916-8ddf-4224-a302-bf72e760ba63","Operation":2},{"MessageId":"f3046eab-d02a-44d1-84bc-474ac8677d91","Operation":2},{"MessageId":"59d2adb9-7c56-49b5-bd3d-55dfe28d26bf","Operation":2},{"MessageId":"7f07f28f-41fa-4624-9b95-651a1cfe3289","Operation":2},{"MessageId":"9126b36e-8c5d-46ce-aa3d-840391fffd53","Operation":2},{"MessageId":"f9d7b513-934d-401c-9678-2aba83c3fd82","Operation":2},{"MessageId":"ef7d2f32-d335-4d1c-ab35-555f0619fb12","Operation":2},{"MessageId":"d83bc6af-c660-47f9-9aa9-67f1c1a862cc","Operation":2},{"MessageId":"60eaef40-5ad7-4a2c-9a2b-538065f95549","Operation":2},{"MessageId":"ada21243-1887-4786-acd6-68641d6a91aa","Operation":2},{"MessageId":"7f05c039-1887-4f9f-b232-821f76d6fd78","Operation":2},{"MessageId":"7783d244-5cc4-4a67-a364-5860444c3d84","Operation":2},{"MessageId":"7fd0ebe2-e92f-4dfa-9e33-e860b4819437","Operation":2},{"MessageId":"2c18ce6d-42d5-4f99-9eb5-be6848eceefd","Operation":2},{"MessageId":"355d11d1-16d6-4b98-b846-25c2123eee40","Operation":2},{"MessageId":"d25c9550-2033-41b4-bc39-016b1242293a","Operation":2},{"MessageId":"2561b836-84d2-4c65-87af-516fe1056dfb","Operation":2},{"MessageId":"51ce9441-1b3b-4a4d-9f1b-1937d5ceb5f6","Operation":2},{"MessageId":"a46ff051-e931-47b8-83db-bb2e3057af2e","Operation":2},{"MessageId":"59c39742-1fff-4c27-aaf5-7bae069f0008","Operation":2},{"MessageId":"a056013c-b0a1-479c-b825-1ee8c9bae001","Operation":2}]');
        //this.Message_Operation(msgTemp).then(data => {
        //    if (data != null) {
        //        this.MessageCache = data.Result;
        //        this.MessageCache.forEach(function (a) {
        //            a.IsRead = false;
        //            a.Status = 'S';
        //        });
        //        this.MessageCacheChanged.emit();
        //        console.info(this.MessageCache);
        //    }
        //});
    }

    IncomingMessage(lst: Array<any>) {
        //this.MessageCache.push(...lst);
        let NotificationAudio: any = document.getElementById("notificationAudio");
        let req = new Array<MessageOperationRequest>();
        for (let i = 0; i < lst.length; i++) {
            let row = lst[i];

            if (row.DeviceType == DeviceTypes.PC) {

                let idx = this.MessageCache.findIndex(a => a.MessageId == row.MessageId);
                if (idx >= 0) {
                    this.MessageCache[idx] = row;
                    this.MessageCacheChanged.emit(row);
                }
                else {
                    if (row.IsRead == false) {
                        if (NotificationAudio && this.masterService.LoggedInUserData != null && this.masterService.LoggedInUserData.IsAlertPopupAudioEnabled) {
                            try {
                                NotificationAudio.play();
                            }
                            catch(err){
                                console.log(err);
                            }
                        }
                        this.MessageCache.unshift(row);
                        this.blink(10);
                    }

                    this.MessageCacheChanged.emit(row);
                }


                if (!row.IsRead && row.DelivereDt == null) {
                    let op = new MessageOperationRequest();
                    op.MessageId = row.MessageId;
                    op.Operation = enumModels.MessageOperations.Delivered;

                    req.push(op);
                }
            }
        }

        this.ResetMessageCache();

        if (req.length > 0) {
            this.Message_Operation(req);
        }
        else {

            //this.MessageCacheChanged.emit();
        }
    }

    ResetMessageCache(): void {
        //this.MessageCache = this.MessageCache.filter(a=>a.IsRead == false);
    }

    //ToggleNotificationOnHeaderClick(): void{
    //   this.NC_Visiblity = false;
    //}

    StaffMessage(req: StaffMessageRequest): Promise<SimpleResponse> {
        let final = _.cloneDeep(req);

        if (final.GroupId <= 0)
            final.GroupId = null;

        if (final.StaffId <= 0)
            final.StaffId = null;

        return this.apiService.postAPI(this.BaseURL, 'Messaging/StaffMessage', req, true).then(data => {
            //console.log(data);
            return data;
        })
    }

    Message_MarkAsRead(MessageId: string): Promise<any> {
        return this.Message_MarkAsRead_Multi([MessageId]);
    }

    Message_MarkAsRead_Multi(Messages: Array<string>): Promise<any> {
        let req = new Array<MessageOperationRequest>();
        for (let i = 0; i < Messages.length; i++) {
            let row = Messages[i];
            let obj = new MessageOperationRequest();
            obj.MessageId = row;
            obj.Operation = MessageOperations.Read;
            req.push(obj);
        }

        return this.Message_Operation(req);
    }

    Message_Remove(MessageId: string): void {
        let idx = this.MessageCache.findIndex(a => a.MessageId == MessageId);
        if (idx >= 0) {
            this.MessageCache.splice(idx, 1);
            this.MessageCacheChanged.emit();
            this.setTitle();
        }
    }

    Message_Remove_Multi(Messages: Array<string>): void {
        Messages.forEach(msg => {
            let idx = this.MessageCache.findIndex(a => a.MessageId == msg);
            if (idx >= 0) {
                this.MessageCache.splice(idx, 1);
            }
        })

        this.MessageCacheChanged.emit();
        this.setTitle();
    }

    Message_Operation(req: Array<MessageOperationRequest>): Promise<SimpleResponse> {
        if (req == null || req.length == 0)
            return null;

        return this.apiService.postAPI(this.BaseURL, "Messaging/Message_Operation", req, false).then(data => {
            if (data == null || data.Result == null)
                return;

            for (let i = 0; i < data.Result.length; i++) {
                let row = data.Result[i];

                let idx = this.MessageCache.findIndex(a => a.MessageId == row.MessageId);
                if (idx >= 0) {
                    this.MessageCache[idx] = row;
                }
            }

            this.ResetMessageCache();
            this.MessageCacheChanged.emit();

            return data;
        });
    }

    Message_ApplyMulti(data: Array<any>): void {
        data.map(row => {
            if (row.EventId != null) {
                row.EventDescription = this.masterService.MasterData_GetMutli(row.PropertyId, row.EventId, enumModels.EntityCodes.EventMaster, row.EventDescription);
                if (row.OwnerId != null)
                    row.OwnerName = this.masterService.MasterData_GetMutli(row.PropertyId, row.OwnerId, enumModels.EntityCodes.Staff, row.OwnerName);
            }
        });
    }

    Message_Search(req: MessageSearch): Promise<ListResponse> {
        if (req == null)
            return null;

        return this.apiService.postAPI(this.BaseURL, "Messaging/Message_Search", req).then(data => {
            if (data != null && data.Result != null)
                this.Message_ApplyMulti(data.Result);

            return data;
        });
    }

    blink(count: number = 5): void {
        const prevTitle = "Unifocus";
        const titleWithCount = '(' + this.MessageCache.length + ') ' + prevTitle;
        const step = () => {
            const newTitle = this.title.getTitle() === prevTitle ?
                titleWithCount : prevTitle;

            this.title.setTitle(newTitle);

            if (--count) {
                this.timeout = setTimeout(step.bind(this), 1000);
            } else {
                this.setTitle();
            }
        };

        clearTimeout(this.timeout);
        step();
    }

    setTitle() {
        let title = "Unifocus"
        if (this.MessageCache && this.MessageCache.length > 0) {
            title = '(' + this.MessageCache.length + ') ' + title;
        }
        this.title.setTitle(title);
    }
}
